import React from "react";
import AppRoutes from "./app/AppRoutes";

function App() {
  return <AppRoutes />;
}

export default App;
